import React from 'react';
import { Section } from './ui/Section';
import { Check, BookOpen, Calendar, Printer, ListChecks, ShieldAlert } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/aSzFRmhQMwh8e9CwHWzxqy/producto_3_am.png';
export function IncludesSection() {
  const items = [{
    icon: BookOpen,
    title: 'PDF completo "3AM RESET"',
    desc: 'La guía maestra con todo el sistema explicado.'
  }, {
    icon: Calendar,
    title: 'Plan de 14 noches',
    desc: 'Micro-cambios por etapas para no abrumarte.'
  }, {
    icon: Printer,
    title: 'Tarjeta imprimible Plan de Rescate 3AM',
    desc: 'Para tener en tu buró cuando despiertas.'
  }, {
    icon: ListChecks,
    title: 'Checklist "Cuarto a prueba de 3AM"',
    desc: 'Asegura tu entorno antes de dormir.'
  }, {
    icon: Check,
    title: 'Tracker de 14 noches',
    desc: 'Simple y detallado para medir tu progreso.'
  }, {
    icon: ShieldAlert,
    title: 'Sección de obstáculos reales',
    desc: 'Calor, pareja que ronca, hijos, viajes, ansiedad.'
  }];
  return <Section background="light" data-id="element-123">
      <h2 className="text-3xl font-serif font-bold text-slate-900 mb-10 text-center" data-id="element-124">
        Qué incluye
      </h2>

      <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14" data-id="element-125">
        {/* Product image */}
        <div className="flex-shrink-0 w-48 sm:w-56 lg:w-64" data-id="element-126">
          <img src={PRODUCT_IMAGE} alt="3AM RESET — Guía práctica" className="w-full h-auto rounded-xl shadow-lg" data-id="element-127" />
        </div>

        {/* Items grid */}
        <div className="flex-1 grid sm:grid-cols-2 gap-4" data-id="element-128">
          {items.map((item, idx) => <div key={idx} className="bg-white p-4 rounded-lg shadow-sm border border-slate-100 flex items-start gap-3" data-id="element-129">
              <div className="bg-indigo-50 p-2 rounded-lg text-indigo-600" data-id="element-130">
                <item.icon className="w-5 h-5" data-id="element-131" />
              </div>
              <div data-id="element-132">
                <h3 className="font-bold text-slate-900 text-sm" data-id="element-133">
                  {item.title}
                </h3>
                <p className="text-xs text-slate-600 mt-1" data-id="element-134">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}